import React from "react";
import TrainJourneyDetail from "../components/TrainJourneyDetail";
import SegmentDetail from "../components/SegmentDetail";
import { DeleteDialog, Modal } from "../../components";
import FileUploadModal from "../../flights/new/files/fileuploadmodal";
import { type UploadFilesConfig, uploadFilesToCoreApi } from "utilities/fileUploadUtils";

interface Props {
  train: server.dto.Train
  onTrainDetailEditClicked: () => void
  onSegmentEditClicked: (segment: server.dto.TrainSegment) => void
  onSegmentDeleted: (segment: server.dto.TrainSegment) => Promise<void>
  onTrainUpdated: (newTrain: server.dto.Train) => void
}

const TrainJourneyDetailScreen = (props: Props) => {
  const [deletingSegment, setDeletingSegment] = React.useState<server.dto.TrainSegment>(undefined);
  const [displayFileUpload, setDisplayFileUpload] = React.useState(false);

  const uploadFiles = (files: File[], uploadConfig: UploadFilesConfig) => {
    return uploadFilesToCoreApi(
      window.CoreApi.File.UploadTrainFiles,
      window.CoreApi.File.UploadTrainFiles.absoluteUrl(),
      {
        files,
        trainId: props.train.id
      },
      uploadConfig
    );
  };

  const onFilesUploaded = async () => {
    const trainRes = await window.Api.Trains.GetTrain(props.train.id);
    props.onTrainUpdated(trainRes.data);
  };
  return <>
    <div className="flex-column gap-bigger">
      <div className="content-section">
        <TrainJourneyDetail
          train={props.train}
          onTrainDetailsEditClicked={props.onTrainDetailEditClicked}
          onFilesAddClick={() => { setDisplayFileUpload(true); }} />
      </div>
      <div className="list-with-gaps card-layout">
        <div className="list-with-gaps-body">
          {props.train.segments.map(seg => (
            <SegmentDetail
              key={seg.id}
              segment={seg}
              train={props.train}
              onEditClicked={props.onSegmentEditClicked}
              onDeleteClicked={setDeletingSegment}
            />
          ))}
        </div>
      </div>
    </div>

    <DeleteDialog
      isOpen={deletingSegment != null}
      message={RESX.GeneralWarnings.AreYouSure}
      handleClose={() => { setDeletingSegment(undefined); }}
      onDelete={async () => {
        props.onSegmentDeleted(deletingSegment);
        setDeletingSegment(undefined);
      }}
    />
    <Modal
      title={RESX.File.Files}
      isOpen={displayFileUpload}
      width={"small"}
      minHeight={400}
      height={750}
      handleClose={() => { setDisplayFileUpload(false); }}
    >
      <FileUploadModal
        canEdit={props.train.permissions.canModify}
        files={props.train.files}
        onFilesChanged={onFilesUploaded}
        upload={uploadFiles}
        deleteEndpoint={window.CoreApi.File.DeleteTrainFile}
        renameEndpoint={window.CoreApi.File.SetTrainFileProperties}
      />
    </Modal>
  </>;
};

export default TrainJourneyDetailScreen;